const hooks = {
  services: {
    before: new Map(),
    after: new Map()
  }
}

/**
 * Register a Hook. Hooks can be used to perform extra processing on given
 * controllers without needing to define a set of routes
 *
 * @param {Object} hook - hook to register, of form:
    {
      when: 'after',
      serviceName: 'digital-assets',
      actionNames: ['upload'],
    }
 * @param {Function} proc - process to be called when the hook is fired
 */
function registerHook(hook, proc) {

  const name = hook.serviceName
  const when = hook.when

  try {

    if(!hooks.services[when].get(name)) {
      hooks.services[when].set(name, [])
    }

    for (const actionName of hook.actionNames) {
      hooks.services[when].get(name).push({
        name,
        actionName: actionName,
        operation: proc,
        when
      })
    }

  }
  catch(e) {
    console.error('Could not register hook', e)
  }

}

export {hooks}
export {registerHook}
